import axiosPost from '../axiosPost';

export const formatosDeImagenDel = async (arg) => {
    const { id } = arg;

    const body = {
        "service": "FormatoDeImagenDel",
        "params": {
            "formatosDeImagenId": id
        }
    }

    try {
        const result = await axiosPost('Y', body, arg)
        return result.data
    } catch (err) {
        console.log(err)
    }
}